import jQuery from 'jquery';

// script for favicon
function setupIcons() {
	const lightSchemeIcon = document.querySelector('link.light-scheme-icon');
	const darkSchemeIcon = document.querySelector('link.dark-scheme-icon');

	function setLight() {
		document.head.append(lightSchemeIcon);
		darkSchemeIcon.remove();
	}

	function setDark() {
		lightSchemeIcon.remove();
		document.head.append(darkSchemeIcon);
	}


	const matcher = window.matchMedia('(prefers-color-scheme:dark)');

	function onUpdate() {
		if (matcher.matches) {
			setDark();
		} else {
			setLight();
		}
	}

	matcher.addListener(onUpdate);
	onUpdate();
}
setupIcons();
// end of favicon script


// Popup diff for scrollbar
const popDiff = () => {
	const screenWidth = screen;
	const bodyWidth = document.querySelector('body');
	const scrollDiff = screenWidth.width - bodyWidth.offsetWidth;

	const doc = document.documentElement
	doc.style.setProperty('--pop-diff', `${scrollDiff}px`)
}
window.addEventListener('resize', popDiff)
popDiff();


/**
 * Use passive listeners to improve scrolling performance
 */
jQuery.event.special.touchstart = {
	setup: function (_, ns, handle) {
		if (ns.includes('noPreventDefault')) {
			this.addEventListener('touchstart', handle, {passive: false});
		} else {
			this.addEventListener('touchstart', handle, {passive: true});
		}
	}
};

jQuery.event.special.touchend = {
	setup: function (_, ns, handle) {
		if (ns.includes('noPreventDefault')) {
			this.addEventListener('touchend', handle, {passive: false});
		} else {
			this.addEventListener('touchend', handle, {passive: true});
		}
	}
};

const appHeight = () => {
	const doc = document.documentElement
	doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()
